import React from 'react'

import Svg from './svg'


export default function Today2Icon({width, height, color, color2 = '--accent-color', ...props}) {
    color = getComputedStyle(document.documentElement)
        .getPropertyValue(color || '--on-content') || color
    color2 = getComputedStyle(document.documentElement)
        .getPropertyValue(color2) || color2

    return <Svg width={width || '16px'} height={height || '16px'} viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g id="today2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <rect id="Rectangle-Copy-9" fill={color} x="7" y="7" width="24" height="24" rx="8"></rect>
            <rect id="Rectangle-Copy-10" fill={color} x="38" y="7" width="24" height="24" rx="8"></rect>
            <rect id="Rectangle-Copy-11" fill={color} x="7" y="38" width="24" height="24" rx="8"></rect>
            <rect id="Rectangle-Copy-12" fill={color2} x="38" y="38" width="24" height="24" rx="8"></rect>
            <rect id="Rectangle-Copy-13" fill={color} x="38" y="69" width="24" height="24" rx="8"></rect>
            <rect id="Rectangle-Copy-14" fill={color} x="69" y="69" width="24" height="24" rx="8"></rect>
            <rect id="Rectangle-Copy-15" fill={color} x="69" y="38" width="24" height="24" rx="8"></rect>
            <rect id="Rectangle-Copy-16" fill={color} x="7" y="69" width="24" height="24" rx="8"></rect>
            <rect id="Rectangle-Copy-17" fill={color} x="69" y="7" width="24" height="24" rx="8"></rect>
        </g>
    </Svg>
}
